import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  button: {
    margin: '5px auto'
  }
};

const enhance = compose();

const button = enhance(({ classes, onClickAction, disabled = false }) => {
  return (
    <Button
      variant="contained"
      color="primary"
      disabled={disabled}
      onClick={onClickAction}
      className={classes.button}
    >
      登録
    </Button>
  );
});

export default withRouter(withStyles(styles)(button));
